import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class CalsoftService {

  sidenavOpen                 : boolean = false;
   paymentSidenavOpen          : boolean = false;
   isDirectionRtl              : boolean = false;
   featuredProductsSelectedTab : any = 0;
   newArrivalSelectedTab       : any = 0;

   /**** Get currency code:- https://en.wikipedia.org/wiki/ISO_4217 *****/
   currency  : string = 'USD';
   language  : string = 'english';

   shipping  : number = 12.95;
   tax       : number = 27.95;



   localStorageCartProducts : any;
   localStorageWishlist : any;
   navbarCartCount : number = 0;
   navbarWishlistProdCount = 0;
   buyUserCartProducts : any;

   constructor(private dialog: MatDialog) {

   }




   public confirmationPopup(message:string)
   {
      // let confirmationPopup: MatDialogRef<ConfirmationPopupComponent>;
      // confirmationPopup = this.dialog.open(ConfirmationPopupComponent);
      // confirmationPopup.componentInstance.message = message;

      // return confirmationPopup.afterClosed();
   }









}
